import { css } from '@emotion/css';

const centerPosition = `
  top: 50%;
  right: 50%;
  transform: translateX(50%) translateY(-50%);
`;

export const inputStyle = css`
  opacity: 0;
  width: 95%;
  height: 95%;
  ${centerPosition}
`;

export const placeholderPosition = css`
  ${centerPosition}
`;
